import React from 'react';

//aggiungo : alle etichette

//tutto a label, children nel contenuto
function Label({ children, duepunti = true, required, className = '', ...ps }) {
    if (!children) {
        return null;
    }
    //aggiungo la classe per il margine a dx se non specificato
    //se requid prende la class  isRequired
    const css = className.split(' ');
    const cnAdd = 'mr-2'; //nome classe da aggiungere
    if (!css.includes(cnAdd)) {
        css.push(cnAdd)
    }
    const cssRequiredClass = 'isRequired';
    if (required && !css.includes(cssRequiredClass)) {
        css.push(cssRequiredClass)
    }
    //se è una stringa e termina con : togli i : anche se non l'hai chiesto esplicitamente+
    const noduepunti = children && typeof children === 'string'
        && children.substr(children.length - 1, children.length) === ':';

    return (
        <label {...ps} className={css.join(' ')}>
            {children}{duepunti && !noduepunti ? ':' : ''}
        </label>
    );

}

export default Label;